// extracted by mini-css-extract-plugin
module.exports = {"confirmSubmit":"styles_confirmSubmit__1N43e","label":"styles_label__1w1CM","detail":"styles_detail__27Zjp","divider":"styles_divider__3IJ-c"};